import { render, staticRenderFns } from "./ObjectStoreSelect.vue?vue&type=template&id=05ed372b&scoped=true"
import script from "./ObjectStoreSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObjectStoreSelect.vue?vue&type=style&index=0&id=05ed372b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed372b",
  null
  
)

export default component.exports